import React, { useState, useEffect } from 'react';
import axios from 'axios';
import "../login/Login.css";
import { useAuth } from '../auth/Auth';
import { useNavigate } from 'react-router-dom';

function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [attempts, setAttempts] = useState(0);
  const [lockoutUntil, setLockoutUntil] = useState(null);
  const {login} = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const savedLockout = localStorage.getItem('loginLockoutUntil');
    if (savedLockout) {
      const lockoutTime = parseInt(savedLockout);
      if (lockoutTime > Date.now()) {
        setLockoutUntil(lockoutTime);
        setError('Невірний пароль, спробуйте, будь ласка, повторити спробу пізніше');
      } else {
        localStorage.removeItem('loginLockoutUntil');
        localStorage.removeItem('loginAttempts');
      }
    }
    
    const savedAttempts = localStorage.getItem('loginAttempts');
    if (savedAttempts) {
      setAttempts(parseInt(savedAttempts));
    }
  }, []);

  const handleLockout = (attempts) => {
    const now = Date.now();
    let lockoutDuration;
    
    if (attempts === 3) {
      lockoutDuration = 2 * 60 * 1000; // 2 minutes
      setError('Невірний пароль, спробуйте, будь ласка, повторити спробу через 2 хвилини');
    } else if (attempts >= 5) {
      lockoutDuration = 10 * 60 * 1000; // 10 minutes
      setError('Невірний пароль, спробуйте, будь ласка, повторити спробу через 10 хвилин');
    }

    if (lockoutDuration) {
      const lockoutUntil = now + lockoutDuration;
      setLockoutUntil(lockoutUntil);
      localStorage.setItem('loginLockoutUntil', lockoutUntil.toString());
    }
  };

  const handleLogin = async (email, password) => {
    if (lockoutUntil && Date.now() < lockoutUntil) {
      setError('Невірний пароль, спробуйте, будь ласка, повторити спробу пізніше');
      return;
    }

    try {
      const response = await axios.post('https://bank2.daolog.net/login', { email, password });
      
      if (response.data.deactivated) {
        setError('Ваш аккаунт було деактивовано');
        return;
      }
      
      if (response.data.success === false) {
        const newAttempts = attempts + 1;
        setAttempts(newAttempts);
        localStorage.setItem('loginAttempts', newAttempts.toString());
        handleLockout(newAttempts);
        if (newAttempts < 3) {
          setError(response.data.message);
        }
        return;
      }

      setAttempts(0);
      localStorage.removeItem('loginAttempts');
      localStorage.removeItem('loginLockoutUntil');
      
      await login(email, password);
      window.location.href = '/';
    } catch (error) {
        console.error('Login failed');
        console.log(error);
        setError('Помилка входу в систему');
    }
  };

  function handleSubmit(event) {
    event.preventDefault();
    setError('');

    if (!email || !password) {
      setError('Будь ласка, заповніть усі поля');
      return;
    }

    handleLogin(email, password);
  }

  const handleMoreInfo = () => {
    navigate('/Price');
  };

  const handleForgotPassword = () => {
    navigate('/ForgotPassword');
  };

  return (
    <div style={{
      marginTop: "120px",
    }}>
      <h1 style={{
        display: "flex",
        flexDirection: "column",
        marginRight: "auto",
        alignItems: "center",
      }}>Login</h1>
      <div className="br-m">
        <div className="container-about">
          <div>
            <form onSubmit={handleSubmit}>
              <label style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "auto",
                marginTop: "10px",
                marginRight: "auto",
                alignItems: "center",
              }}>
                Email:<br />
                <input
                  className='input-stl'
                  style={{marginTop: "10px"}}
                  placeholder='Email'
                  type="email"
                  name="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  required
                />
              </label>
              <br />
              <label style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "auto",
                marginRight: "auto",
                alignItems: "center",
              }}>
                Password:<br />
                <input
                  className='input-stl'
                  style={{marginTop: "10px"}}
                  placeholder='Password'
                  type="password"
                  name="password"
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                  required
                />
              </label>
              <button type="submit" 
              className='download-button'
              style={{
                display: "flex",
                flexDirection: "column",
                marginLeft: "auto",
                marginTop: "20px",
                marginRight: "auto",
                alignItems: "center",
                minWidth: "50px",
                maxWidth: "100px",
                width: "100%",
              }}
              disabled={lockoutUntil && Date.now() < lockoutUntil}>
                Login
              </button>
              {error && (
                <div style={{
                  color: "red",
                  textAlign: "center",
                  marginTop: "10px"
                }}>
                  {error}
                </div>
              )}
              <br />
            </form>
          </div>
        </div>
      </div>
      <div style={{
        textAlign: "center",
        marginTop: "20px"
      }}>
        <p style={{cursor: "pointer", color: "blue", textDecoration: "underline"}} onClick={handleForgotPassword}>
        Forgot your password?
        </p>
        {/* <p>Якщо Ви новий користувач натиснувши на кнопку нижче потрапите на сторінку з інформацією:</p>
        <button 
          onClick={handleMoreInfo}
           className="download-button-ch"
          style={{
            marginTop: "10px",
            minWidth: "120px"
          }}>
          Детальніше
        </button> */}
      </div>
    </div>
  );
}

export default Login;